import { clsx } from 'clsx';
import { NavLink, useParams } from 'react-router';

import { buildQueryString } from '../../../../Buyer/utils/queryParams';
import {
  DEFAULT_TAB_PATH,
  getTabConfigByPath,
  TAB_CONFIG_LIST,
} from '../../config/tabConfig';
import { trackTabClicked } from '../../tracking';

export const CustomersTabBar = () => {
  const queryString = buildQueryString();
  const { tab: tabParam } = useParams<{ tab: string }>();
  // The bar renders above the tab outlet, so the active tab comes from the route
  // rather than a config prop. An unrecognised param means the outlet is about to
  // redirect to the default tab, which is where the seller is leaving from.
  const currentTab =
    getTabConfigByPath(tabParam ?? '')?.path ?? DEFAULT_TAB_PATH;

  return (
    <nav>
      <div className="flex w-full items-start gap-l border-b border-structure-60">
        {TAB_CONFIG_LIST.map((tab) => (
          <NavLink
            key={tab.key}
            to={`/pay/customers/${tab.path}${queryString}`}
            // Re-clicking the active tab navigates nowhere, so it isn't a switch.
            onClick={() => {
              if (tab.path !== currentTab) {
                trackTabClicked({ from: currentTab, to: tab.path });
              }
            }}
            className={({ isActive }) =>
              clsx(
                'flex min-h-[52px] cursor-pointer items-center justify-center whitespace-nowrap px-xl py-m text-xl leading-[normal] no-underline m:px-m',
                isActive
                  ? 'border-b-[1.5px] border-black font-bold text-primary-10'
                  : 'font-reg text-structure-40',
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
